export const PERIOD_TYPES = {
    DAY: 1,
    WEEK: 7,
    MONTH: 28,
    ALL: 'all',
}



// WEBPACK FOOTER //
// ./utils/clan_management/periods.js